export const customStylesAcc = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '450px', border: '1px solid #f1f1f1', right: '1px', zIndex: 2 }),
  control: (base, props) => ({ maxWidth: `${props.selectProps.maxWidth-40}px`, '& input': { maxWidth: `${props.selectProps.maxWidth-40}px`, overflowX: 'hidden' }, height: '34px', position: 'relative', boxSizing: 'border-box', padding: 3 }),
  menuList: base => ({ ...base, maxHeight: '38vh' }),
  dropdownIndicator: () => ({ display: 'none' })
}

export const customStylesContact = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '370px', border: '1px solid #f1f1f1', right: '1px', zIndex: 2 }),
  menuList: base => ({ ...base, maxHeight: '38vh', textAlign: 'left' }),
  control: (base, props) => ({ maxWidth: `${props.selectProps.maxWidth-40}px`, '& input': { maxWidth: `${props.selectProps.maxWidth-40}px`, overflowX: 'hidden' }, height: '34px', position: 'relative', boxSizing: 'border-box' }),
  dropdownIndicator: () => ({ display: 'none' })
}

export const customStylesGST = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '500px', border: '1px solid #f1f1f1', right: '1px', zIndex: 2 }),
  menuList: base => ({ ...base, maxHeight: '38vh' }),
  control: (base, props) => ({ maxWidth: `${props.selectProps.maxWidth-40}px`, '& input': { maxWidth: `${props.selectProps.maxWidth-40}px`, overflowX: 'hidden' }, height: '34px', position: 'relative', boxSizing: 'border-box' }),
  dropdownIndicator: () => ({ display: 'none' })
}

export const customStylesSplit = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', border: '1px solid #f1f1f1', zIndex: 2 }),
  dropdownIndicator: () => ({ display: 'none' })
}

export const customStylesSplit200 = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '200px', border: '1px solid #f1f1f1', zIndex: 2 }),
  dropdownIndicator: () => ({ display: 'none' })
}

export const customStylesSplit350 = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '350px', border: '1px solid #f1f1f1', fontSize: 14, zIndex: 2 }),
  menuList: base => ({ ...base, maxHeight: '148px' }),
  dropdownIndicator: () => ({ display: 'none' })
}

export const customStylesSplit400 = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '400px', border: '1px solid #f1f1f1', zIndex: 2 }),
  dropdownIndicator: () => ({ display: 'none' })
}

export const customStylesSplit450 = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '450px', border: '1px solid #f1f1f1', fontSize: 14, zIndex: 2 }),
  menuList: base => ({ ...base, maxHeight: '180px' }),
  dropdownIndicator: () => ({ display: 'none' })
}

export const customStylesSplit550 = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '550px', border: '1px solid #ffffcc', zIndex: 2 }),
  menuList: base => ({ ...base, maxHeight: '180px' }),
  dropdownIndicator: () => ({ display: 'none' })
}

export const customStylesCode400 = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '400px', border: '1px solid #f1f1f1', zIndex: 2 })
}

export const customStylesCode450 = {
  menu: base => ({ ...base, backgroundColor: '#f8f8f8', width: '450px', border: '1px solid #f1f1f1', zIndex: 2 })
}

export const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};



// WEBPACK FOOTER //
// ./src/components/UI/select-styles.js